export const NUM_CURATED_TRAILS = 400; // thousand
export const NUM_USERS = 55; // million
export const LOGGED_DISTANCE = 1368000; // meters
